const doc = [({"da":({"models":({"email":({"confirmable":({"is_already_used":"er allerede brugt"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;